import { Field, Form } from '~/components';
import React from 'react';

function LineSettingsPrepaymentsTab() {
  return (
    <Form.Section title="General">
      <Form.Control>
        <Field.Checkbox
          label="Include the project name on each prepayment invoice line"
          name="includePrepaymentProject"
        />
      </Form.Control>
    </Form.Section>
  );
}

export default LineSettingsPrepaymentsTab;
